var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-container",on:{"click":_vm.goToLink}},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.tranlatedTitle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }